module.exports = __webpack_public_path__ + "img/shops-bg.d898b33f.jpg";